<template>
  <h3>Search For People</h3>
  <p>Note: The search types allow you to build a query automatically (without manually selecting Conditions).</p>
  <DataTableSearchBuilderComponent 

  :data-url="this.getPeopleBySearchCriteriaUrl" 
  :column-list-d-b="this.personDataColumnNames" 
  :column-list-pretty="this.personDataColumnNamesPretty" 
  column-name-id="personId" 
  :center-column-indexes="[10]"
  :date-column-indexes="[10]"
  :order-column-index="10"
  :rows-per-page="10"
  :show-search="false"
  plural-data-name="people"
  order-direction="desc"
  ref="personsDatatable"

  >

  <template #actionColumnEditSlot="actionColumnEditSlot">
    <td class="actionColumn tdclass">
      <div class="material-icons forIconEdit text-success actionButton"  @click="this.ClickedEditPerson(actionColumnEditSlot)" :id="'btnEditPerson_' + actionColumnEditSlot.personId"> edit </div>

      <div class="material-icons forIconTransfer blueButton actionButton"  @click="this.ClickedRenewTransferPerson(actionColumnEditSlot)" :id="'btnTransferPerson_' + actionColumnEditSlot.personId"> input </div>

    </td>
    
  </template>

  </DataTableSearchBuilderComponent>

</template>

<script>

import DataTableSearchBuilderComponent from "@/components/dataSupport/DataTableSearchBuilder.vue";
import { store } from "@/store/store.js";

export default {
  components:{
    DataTableSearchBuilderComponent
  },
  data() {
    return{
      store,
      getPeopleBySearchCriteriaUrl:"",
      personDataColumnNames:['lastName','firstName','middleName', 'contractNumber','securityTypeName', 'spotDTSID','countryName', 'companyName','dodCivYN', 'loaAWYN', 'armingStatus', 'armingConfirmedDatePretty'],
      personDataColumnNamesPretty:['Last Name','First Name','Middle Name','Contract Number', 'Security Type', 'LOA','Nationality', 'Employer','DoD Civillian', 'LOA-AW', 'Status', 'Arming Confirmed Date'],
    };
  },
  created() {
    this.getPeopleBySearchCriteriaUrl = this.store.webAPIUrl + "people/GetAllPersonsBySearchCriteria"; 
    console.log(this.getPeopleBySearchCriteriaUrl);
  },
  computed: {},
  methods: {
    ClickedEditPerson(persObj){
        this.store.tempPersonId = persObj.personId;
        this.$router.push({ name: 'AdminPersonEditPage', params: { personId: persObj.personId } });
      },
      ClickedRenewTransferPerson(persObj){
        console.log(persObj);
        
        this.$router.push({
          name: 'personTransfer',
          params: {
            personID: persObj.personId,
            firstName: persObj.firstName,
            lastName: persObj.lastName,
            contractId: persObj.contractId,
            contractNumber: persObj.contractNumber
          }
        });
        
      }
  },
};

</script>
  
<style scoped>
p{
  text-align: left;
}
.actionButton{
  cursor: pointer;
}
</style>